import CreateGameForm from './create-game-form'
import JoinGameForm from './join-game-form'
import React, { PropTypes } from 'react'
import { createGame } from 'app/actions/game'

const GamePanel = React.createClass({

  propTypes: {
    app     : PropTypes.object.isRequired,
    history : PropTypes.object.isRequired
  },

  joinGame(shortcode, isFunmaster=false) {
    this.props.history.pushState(null, `/game/${ shortcode }`, {
      // We use this query string to determine if the user
      // is the "active" ""device (the fun-master)
      //
      // The key/value pair is slightly obfuscated to reasonably
      // avoid cheating
      fm: isFunmaster ? 1 : 0
    })
  },

  notifyError() {
    alert('Oh no! An error occured :(')
  },

  createGame() {
    this.props.app.push(createGame, null, (error, { shortcode }) => {
      return error ? this.notifyError(error) : this.joinGame(shortcode, true)
    })
  },

  render() {
    return (
      <div className="row-flex pad-4-top">
        <CreateGameForm onSubmit={ this.createGame } />
        <JoinGameForm onSubmit={ this.joinGame } />
      </div>
    )
  }

})

export default GamePanel



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/game-panel.jsx
 **/